import * as R from 'ramda'
import { createSelector } from 'reselect'
import {
  entitiesSelector,
} from 'helpers/ComponentSelectorUtil'

import {
  employeeImages,
} from 'containers/User/EmployeeImage/selectors'
import {
  employeeList,
} from 'containers/User/EmployeeList/selectors'

const newSubstituteState = state => state.newSubstitute
const substitutesState = state => state.substitutes

const substitutesWithImages = createSelector(
  substitutesState,
  employeeImages,
  (substitutes, images) => {
    const usernames = R.keys(substitutes)
    return R.mergeDeepLeft(
      substitutes,
      R.pick(usernames)(images)
    )
  }
)

const hasIdProperty = R.has('id')
const hasNotIdProperty = R.compose(
  R.not,
  hasIdProperty
)

const filterCreateSubstitutes = R.compose(
  R.filter(hasNotIdProperty),
  R.values
)

const filterPatchSubstitutes = R.compose(
  R.filter(hasIdProperty),
  R.values
)

const createSubstituteSelector = createSelector(
  substitutesState,
  filterCreateSubstitutes
)

const patchSubstituteSelector = createSelector(
  substitutesState,
  filterPatchSubstitutes
)

const substitutesWithImagesValues = state => Object.values(substitutesWithImages(state))
const newSubstituteSelector = createSelector(
  newSubstituteState,
  employeeList,
  R.prop
)

export {
  substitutesState,
  substitutesWithImages,
  substitutesWithImagesValues,
  newSubstituteSelector,
  createSubstituteSelector,
  patchSubstituteSelector,
}
